import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";

import { cn } from "@/lib/utils";

function AudioSlider({
  className,
  defaultValue,
  value,
  min = 0,
  max = 100,
  withThumb = true,
  withTrack = true,
  ...props
}: React.ComponentProps<typeof SliderPrimitive.Root> & {
  withThumb?: boolean;
  withTrack?: boolean;
}) {
  const _values = React.useMemo(
    () =>
      Array.isArray(value)
        ? value
        : Array.isArray(defaultValue)
          ? defaultValue
          : [min, max],
    [value, defaultValue, min, max]
  );

  return (
    <SliderPrimitive.Root
      data-slot="slider"
      defaultValue={defaultValue}
      value={value}
      min={min}
      max={max}
      className={cn(
        "relative flex w-full touch-none items-center select-none data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col",
        className
      )}
      {...props}
    >
      <SliderPrimitive.Track
        data-slot="slider-track"
        className={cn(
          "bg-slider relative grow overflow-hidden rounded-full data-[orientation=horizontal]:h-2.5 data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-1.5"
        )}
      >
        {withTrack && (
          <SliderPrimitive.Range
            data-slot="slider-range"
            className={cn(
              "bg-primary absolute data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full rounded-full"
            )}
          />
        )}
      </SliderPrimitive.Track>
      {withThumb
        ? Array.from({ length: _values.length }, (_, index) => (
            <SliderPrimitive.Thumb
              data-slot="slider-thumb"
              key={index}
              className="block relative shrink-0 rounded-full bg-black transition-[color,box-shadow]  focus-visible:outline-hidden aria-disabled:pointer-events-none w-0.5 h-5"
              // style={{
              //   width: thumbSize,
              //   height: thumbSize,
              // }}
            />
          ))
        : null}
    </SliderPrimitive.Root>
  );
}

export { AudioSlider };
